export const emailRequired = 'Please enter the email the report was sent to';

export const googleAdsImpressionsRequired = 'Please confirm total google ads impressions';

export const googleAdsClicksRequired = 'Please confirm total google ads clicks';

export const mortgageFilterSubmissionRequired =
  'Please confirm the total mortgage filter submissions';

export const emailValidRequired = 'Please enter a valid email';
export const emailPattern = {
  value:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  message: emailValidRequired,
};

export const DownloadReportForm = [
  {
    id: 'email',
    name: 'lender-admin-email',
    required: emailRequired,
    placeholder: 'Email',
    pattern: emailPattern,
    type: 'text',
    label: 'Email Report Was Sent',
  },
  {
    id: 'google-ads-impressions',
    name: 'google-ads-impressions',
    required: googleAdsImpressionsRequired,
    placeholder: 'Google Ads Impressions',
    type: 'number',
    label: 'Google Ads Impression Totals',
  },
  {
    id: 'google-ads-clicks',
    name: 'google-ads-clicks',
    required: googleAdsClicksRequired,
    placeholder: 'Google Ads Clicks',
    type: 'number',
    label: 'Google Ads Total Clicks',
  },
];

export const financeLenderRequired = 'Please enter the unique finance lender identification';

export const freeTrialReportRequired = 'Please enter the unique free trial report identification';

export const ConfirmVerificationInfoForm = [
  {
    id: 'finance-lender',
    name: 'finance-lender',
    required: financeLenderRequired,
    placeholder: 'Finance Lender Identification',
    type: 'text',
    label: 'Finance Lender Identification',
  },
  {
    id: 'free-trial-report',
    name: 'free-trial-report',
    required: freeTrialReportRequired,
    placeholder: 'Free Trial Report Identification',
    type: 'text',
    label: 'Free Trial Report Identification',
  },
];

export const freeTrialModalConfirmInfoTitle = 'Please Verify The Identification Information';
export const freeTrialModalConfirmInfoSubtitle =
  'We are unable to locate report with info provided';

export const noFreeTrialReportLocated = 'No Free Trial Report Located';
export const locateFreeTrialReport = 'Locate Free Trial Report';

export const downloadFreeTrialReport = 'Download Free Trial Report';
export const pleaseConfirmInformation = 'Please Confirm Information';
export const pleaseVerifyInformationEntered = 'Please Verify Information Entered';

export const comprehensiveReportSummary = 'Comprehensive Report Summary';

export const downloadReport = 'Download Report';
export const PDF_REPORT_SUCCESSFULLY_DOWNLOADED = 'PDF Report Successfully Downloaded!';
